import { AreaVisitsIcon } from 'src/components/insights/icons/area-visits'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import dynamic from 'next/dynamic'
import preview from 'src/assets/images/widgets-previews/area-visits-map.png'

const AreaVisits = dynamic(() => import('src/components/insights/area-visits/area-visits'), { ssr: false })

export const AreaVisitsWidget: InsightBuilderWidget = {
  id: 'area-visits',
  name: 'Area Visits',
  type: 'Area Visits',
  icon: AreaVisitsIcon,
  component: AreaVisits,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'intermediate',
}
